export const AUTH_TOKEN = "@auth_token";
export const REFRESH_TOKEN = "@refresh_token";
export const FCM_TOKEN = "@fcm_token";
export const USER = "@user";
export const PERMISSIONS = "@permissions";
export const TOKEN_PAYLOAD_KEY = "Authorization";
export const THEME = "@theme";
